
import React from 'react';

interface IProps {
  style?: any;
  
}

export const EllipseIcon:React.FC<IProps> = (props: IProps) => {
  return (
    <svg width="200" height="100" viewBox="0 0 200 100" fill="none" xmlns="http://www.w3.org/2000/svg">
        <ellipse cx="100" cy="50" rx="100" ry="50" fill="#dee2eb"/>
    </svg>

    
    
  )
}
